var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, stripe: "", border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "poId",
                  label: _vm.$t("billingPage.POID"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderId",
                  label: _vm.$t("form.oddNumbers"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "returnOrderId",
                  label: _vm.$t("ReturnOrderText"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "consignmentNo",
                  label: _vm.$t("CustomerFunction.common.logisticsNo"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "description",
                  label: _vm.$t("billingPage.comments"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "gmtCreate",
                  label: _vm.$t("billingPage.createTime"),
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updatedBy",
                  label: _vm.$t("BjDialogListConfig.Operator"),
                  align: "center",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible2, width: "400px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible2 = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("billingPage.description") } },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      maxlength: _vm.MAX_LENGTH.BILLMAX,
                      "show-word-limit": "",
                      autosize: "",
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible2 = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible3, width: "400px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible3 = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            { ref: "form2", attrs: { model: _vm.form2, rules: _vm.rules } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.quantity"),
                    prop: "quantity",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                    model: {
                      value: _vm.form2.quantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "quantity", $$v)
                      },
                      expression: "form2.quantity",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible3 = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }